import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ImageCard from '../../image-card'

import './index.styl'

const Location = ({ pageData }) => {
  return (
    <div className="location">
      {pageData.map(item => (
        <div key={item['_id']} className="location__item">
          <h5 className="location__item-name">{item['company_name']}</h5>
          <div className="location__item-address">{item.address}</div>
          <div className="location__item-tel">
            <span className="location__item-label">TEL:</span>
            {item.tel}
          </div>
          <div className="location__item-fax">
            <span className="location__item-label">FAX:</span>
            {item.fax}
          </div>
          <div className="location__item-mail">
            <span className="location__item-label" >E-Mail:</span>
            <a href={`mailto:${item['e_mail']}`}>{item['e_mail']}</a>
          </div>
        </div>
      ))}
    </div>
  )
}

Location.propTypes = {}

export default Location
